import React, {Component} from 'react'

import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import AddIcon from '@material-ui/icons/AddCircle'
import DeleteIcon from '@material-ui/icons/Delete' 
import ImageViewer from '../../../ui/ImageViewer'

import PaperBlock from "../../../ui/PaperBlock"

import {config} from "../../../config"

/**
 * @props images - список изображений полученный через api.inventory.image.list.
 * 
 * @props-disabled onImageClick(n) - событие нажатия на изображение.
 * @props onAddImageClick - событие на нажатие кнопки Добавить.
 * @props onImageDeleteClick(n) - событие нажатия на кнопку удаления изображение.
 */

class ImagePanel extends Component {

    constructor(props) {
        super(props)
        this.state = {
            dialog: undefined
        }
    }

    render() {

        return <PaperBlock style = {{display: "flex", flexDirection: "column", width: "auto"}}>

            {this.state.dialog}
            
            <div style = {{display: "flex", justifyContent: "center", alignItems: "center"}}>

                <Typography style = {{flex: "1 1 auto"}}>Фото</Typography>

                <Button
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onAddImageClick === "function") {
                            this.props.onAddImageClick()
                        }
                    }}
                >
                    <AddIcon />
                    Добавить
                </Button>

            </div>

            <div
                style={{
                    marginTop: "10px",
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: '10px',
                }}
            >
                { this.props.images.map(
                    (image, n) => {
                        let {id, filename} = image
                        return <div 
                            key={n}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                aspectRatio: "3/4",
                                position: "relative",
                            }}
                        >
                            <img 
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'cover',
                                    objectPosition: 'center',
                                }}
                                src={ `${config.imageApiHost}/image/${filename}?sz=300,300` } 
                                alt={`Image ${n}`}
                                
                                // Показ картинки добавлен в компонент.
                                // Событие onClick теперь занято.
                                //
                                // onClick={e => {
                                //     e.stopPropagation()
                                //     if (typeof this.props.onImageClick === "function") {
                                //         this.props.onImageClick(image)
                                //     }
                                // }} 

                                onClick = {() => { 
                                    this.setState({
                                        dialog:<ImageViewer
                                            image={`${config.imageApiHost}/image/${image.filename}`}
                                            onClick={()=>{
                                                this.setState({dialog: undefined})
                                            }}
                                        />
                                    })
                                }}

                            />

                            {/* Иконка удаления */}

                            <IconButton
                                size="small"
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                    borderRadius: 0,
                                }}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    if (typeof this.props.onImageDeleteClick === "function") {
                                        this.props.onImageDeleteClick(image)
                                    }
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>

                        </div>
                    }
                ) }
            </div>

        </PaperBlock>
    }

}

export default ImagePanel
